import type { IOperationResponse } from "../services/api";

/** Terminal operation statuses that can no longer be funded. */
export const TERMINAL_OPERATION_STATUSES = [
  "completed",
  "failed",
  "cancelled",
  "canceled",
  "expired",
] as const;

const TERMINAL_OPERATION_STATUS_SET = new Set<string>(
  TERMINAL_OPERATION_STATUSES
);

/**
 * Push-funding sub-statuses where the backend allows minting a cash-deposit
 * payment link (`POST .../cash-deposit-link`). Must match the controller gate —
 * `fundingStatus: null` means the FSM has not parked yet (422
 * OPERATION_NOT_AWAITING_FUNDING).
 */
export const FUNDABLE_CASH_STATUSES = new Set([
  "awaiting_funding",
  "barcode_issued",
]);

/**
 * A CASH_DEPOSIT operation parked at the funding gate — the row becomes a
 * "Deposit" CTA that hands off to the cash-deposit widget.
 */
export const isCashDepositPending = (op: IOperationResponse): boolean =>
  op.fundingMethod === "CASH_DEPOSIT" &&
  FUNDABLE_CASH_STATUSES.has(op.fundingStatus ?? "") &&
  !TERMINAL_OPERATION_STATUS_SET.has((op.status ?? "").toLowerCase());
